module.exports = __webpack_public_path__ + "static/media/LogoMonDje.0991af95.png";